import React from "react";
import ContactComponent from "../_shared/contact/contact.component";
import FormComponent from "../_shared/form/form.component";
import ImageBackgroundComponent from "../_shared/image-background/image-background.component";
import { useWindowWidth } from "../hooks/window.hook";

export default function BookTableComponent() {
  const width = useWindowWidth();
  const breakpoint = 720;

  if (width < breakpoint) {
    return (
      <div className="d-f-c-c bg-s">
        <ImageBackgroundComponent class="table-2-bg-s" />
        <div className="mi-ma-w-v-90 m-t-20">
          <FormComponent
            title="BOOK_TABLE.TITLE"
            color="bg-backgroundSecondary text-foregroundSecondary"
            border="b-h-p"
            font="f-p"
            form="book-table"
          />
        </div>
        <ImageBackgroundComponent class="table-2-bg-s m-t-20" />
        <div className="w-v-90 m-t-20">
          <ContactComponent color="bg-s" border="b-h-s" font="f-s" />
        </div>
      </div>
    );
  } else {
    return (
      <div className="d-f-c-c bg-s">
        <ImageBackgroundComponent class="table-2-bg" />

        <div className="d-f-c-c mi-ma-w-p-80 m-t-20">
          <FormComponent
            title="BOOK_TABLE.TITLE"
            color="bg-backgroundSecondary text-foregroundSecondary"
            border="b-h-p"
            font="f-p"
            width="mi-ma-w-p-100"
            form="book-table"
          />
        </div>

        <div className="mi-w-p-100 m-t-20 flex item-center justify-center">
          <div className="mi-w-p-50">
            <ImageBackgroundComponent class="table-2-bg mi-w-p-50" />
          </div>
          <div className="mi-w-p-5"></div>
          <div className="mi-w-p-40">
            <ContactComponent color="bg-s" border="b-h-s" font="f-s" />
          </div>

          <div className="mi-w-p-5"></div>
        </div>
      </div>
    );
  }
}
